module.exports = __webpack_public_path__ + "img/组5(1).1c06f832.png";